import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInProgress = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 30,
	viewBox: "0 0 31 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15.5 27.5C22.4036 27.5 28 21.9036 28 15C28 8.09644 22.4036 2.5 15.5 2.5C8.59644 2.5 3 8.09644 3 15C3 21.9036 8.59644 27.5 15.5 27.5ZM19.9115 10.5884L21.75 8.75V13.125H17.3748L19.0265 11.4734C17.8948 10.3406 16.2315 9.74064 14.4425 10.1099C12.5205 10.5067 10.9795 12.063 10.5995 13.988C9.96824 17.1868 12.4114 20 15.4997 20C18.0742 20 20.2 18.0439 20.4706 15.5408C20.5044 15.2301 20.7734 15 21.0859 15C21.4609 15 21.7528 15.3282 21.7109 15.7007C21.3615 18.8182 18.7086 21.25 15.4997 21.25C11.6645 21.25 8.62478 17.7773 9.36044 13.811C9.82609 11.2967 11.8638 9.28766 14.3827 8.84766C16.5415 8.47102 18.5409 9.2148 19.9115 10.5884Z",
		fill: "#FFCE4D"
	})]
});
const ForwardRef = forwardRef(SvgInProgress);
export { ForwardRef as ReactComponent };
